// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p665x","container__bees_icon":"styles_container__bees_icon__hZDZJ","container__footer":"styles_container__footer__WP2Ya"};